import React from "react";
import { SwitchGeneric } from "./SwitchGeneric";

export function SwitchIO({
    deviceStatus,
    remote,
    handleSendAction = actionStatus => {},
}) {
    //VIEW
    return (
        <SwitchGeneric
            deviceStatus={deviceStatus}
            handleSendAction={handleSendAction}
            remote={remote}
            leftButtonName={"0"}
            rightButtonName={"I"}

            leftSideStatus={0}
            rightSideStatus={1}

            offStatus={0}
        />
    );
}